import { render, staticRenderFns } from "./MacroeconomicIndicatorsModal.vue?vue&type=template&id=437068ed&scoped=true&"
import script from "./MacroeconomicIndicatorsModal.vue?vue&type=script&lang=js&"
export * from "./MacroeconomicIndicatorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437068ed",
  null
  
)

export default component.exports